import React from 'react';
import MainLayoutTemplate from '../layout/MainLayoutTemplate/MainLayoutTemplate';
import { StorageBoxProvider } from './StorageBoxContext';
import StorageBoxShellSidebar from './components/StorageBoxShellSidebar';
import StorageBoxWorkspace from './pages/StorageBoxWorkspace';
import './StorageBoxPage.css';

export default function StorageBoxApp() {
  return (
    <StorageBoxProvider>
      <MainLayoutTemplate
        layoutClassName="posts-page-layout--cashflow posts-page-layout--storagebox"
        showHeaderSearch={false}
        sidebar={<StorageBoxShellSidebar />}
      >
        <StorageBoxWorkspace />
      </MainLayoutTemplate>
    </StorageBoxProvider>
  );
}
